/* eslint-disable no-unused-vars */
import * as React from "react";
import { FormControl, InputLabel, LinearProgress, Select } from "@mui/material";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { ACTUALIZAR_LISTA, OPEN_REDUX } from "../../../../redux/constanst";
import Swal from "sweetalert2";
import { hosting } from "../../models/buscar";

export default function AgregarEditarUsuario(props) {
  const { datos, datos2 } = props;
  const { actualizarLista, openRedux } = useSelector(
    (state) => state.userState
  );

  const dispatch = useDispatch();
  const [extension, setExtension] = React.useState(
    datos?.extension ? datos?.extension : ""
  );
  const [formDisabled, setFormDisabled] = React.useState(false);
  const [name, setName] = React.useState(datos?.name ? datos?.name : "");
  const [channel, setChannel] = React.useState(
    datos?.channel ? datos?.channel : ""
  );
  const [status, setStatus] = React.useState(
    datos?.status ? datos?.status : ""
  );
  const updateNumber = (e) => {
    const val = e.target.value;
    var regexp = /^([0-9])*$/;
    const found = val.match(regexp);
    if (found) {
      setExtension(e.target.value);
    }
  };

  const enviar = async (data) => {
    setFormDisabled(true);
    axios
      .get(
        `${hosting}/mimegacall/api/addEdit_anexos.php?extension=${extension}&name=${name}&channel=${channel}&status=${status}`
      )
      .then((response) => {
        dispatch({ type: ACTUALIZAR_LISTA, actualizarLista: !actualizarLista });
        if (response.data.type === "SQL") {
          Swal.fire(
            "Error al crear Anexo, pongase en contacto con el administrador",
            ``,
            "error"
          ).then(() => {
            return;
          });
        } else {
          Swal.fire(response.data.mensaje, ``, response.data.type).then(
            (result) => {
              dispatch({
                type: ACTUALIZAR_LISTA,
                actualizarLista: !actualizarLista,
              });
            }
          );
        }

        dispatch({ type: OPEN_REDUX, openRedux: !openRedux });
        setFormDisabled(false);
      })
      .catch(function (error) {
        console.log(error);
      });

    data.preventDefault();
  };

  return (
    <Paper sx={{ margin: "auto", overflow: "hidden" }}>
      <form
        onSubmit={(e) => {
          enviar(e);
        }}
      >
        <Grid
          style={{ padding: "20px" }}
          container
          spacing={0}
          alignItems="center"
        >
          <Grid item xs={4}>
            <FormControl sx={{ m: 1, width: "99.5%" }} variant="outlined">
              <TextField
                id="channel"
                label="Channel"
                defaultValue={`SIP/${extension}`}
                value={`SIP/${extension}`}
                disabled={true}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControl sx={{ m: 1, width: "99%" }} variant="outlined">
              <TextField
                id="nombre"
                type={"text"}
                label="Nombre"
                defaultValue={datos?.name}
                on
                onLoad={(e) => {}}
                onChange={(e) => {
                  setName(e.target.value);
                }}
                disabled={formDisabled}
              />
            </FormControl>
          </Grid>

          <Grid item xs={4}>
            <FormControl sx={{ m: 1, width: "99.5%" }} variant="outlined">
              <TextField
                id="extension"
                label="extension"
                type="text"
                value={extension}
                defaultValue={extension}
                pattern="[0-9]{0,13}"
                disabled={datos?.channel}
                onChange={updateNumber}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl sx={{ m: 1, width: "99.5%" }} variant="outlined">
              {!formDisabled ? (
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ mr: 1 }}
                  disabled={formDisabled}
                >
                  GUARDAR
                </Button>
              ) : (
                <LinearProgress />
              )}
            </FormControl>
          </Grid>
        </Grid>
      </form>
    </Paper>
  );
}
